// extracted by mini-css-extract-plugin
module.exports = {"loadingMessage":"loadingMessage-2HeGeTHMOCjfZc3bs2P-PG","spinner":"spinner-336wsr-ZICQQN4HULK8PdN","text":"text-2GleObCWh4Efj8hziXQ99i"};